import { render, staticRenderFns } from "./gTest.vue?vue&type=template&id=b22cb43c&scoped=true"
import script from "./gTest.vue?vue&type=script&lang=js"
export * from "./gTest.vue?vue&type=script&lang=js"
import style0 from "./gTest.vue?vue&type=style&index=0&id=b22cb43c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b22cb43c",
  null
  
)

export default component.exports